import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  RuntimeException1r3t0zl97011n as RuntimeException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  BufferOverflow_SUSPEND_getInstanceob833ibjouyy as BufferOverflow_SUSPEND_getInstance,
  BufferOverflow_DROP_OLDEST_getInstanceckq6sjfawt4w as BufferOverflow_DROP_OLDEST_getInstance,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import {
  Channel3r72atmcithql as Channel,
  _ChannelResult___get_isSuccess__impl__odq1z9t6ktwy0g0q0f as _ChannelResult___get_isSuccess__impl__odq1z9,
  _ChannelResult___get_isClosed__impl__mg7kuu3a26on4apn4j4 as _ChannelResult___get_isClosed__impl__mg7kuu,
  close$defaultlxi0kykibhye as close$default,
  cancel$default2imfx8rp1ubvu as cancel$default,
  SendChannel38sllbxw662ws as SendChannel,
  ReceiveChannel24wu5e2tj9lbp as ReceiveChannel,
} from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'kotlin.apply' call
        var this_0 = new (WebSocketChannelsConfig())();
        this_0.v5b_1 = this_0.u5d();
        this_0.w5b_1 = this_0.u5d();
        tmp.u5b_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var WebSocketChannelsConfigClass;
function WebSocketChannelsConfig() {
  if (WebSocketChannelsConfigClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance();
        this.v5b_1 = Companion_getInstance_0().v5d_1;
        this.w5b_1 = Companion_getInstance_0().v5d_1;
      }
      u5d() {
        return Companion_getInstance_0().v5d_1;
      }
    }
    initMetadataForClass($, 'WebSocketChannelsConfig', WebSocketChannelsConfig);
    WebSocketChannelsConfigClass = $;
  }
  return WebSocketChannelsConfigClass;
}
function from(_this__u8e3s4, config) {
  // Inline function 'kotlin.with' call
  var tmp;
  if (config.w5d_1 === 2147483647) {
    tmp = Channel(2147483647);
  } else if (config.x5d_1.equals(ChannelOverflow_SUSPEND_getInstance())) {
    tmp = Channel(config.w5d_1, BufferOverflow_SUSPEND_getInstance());
  } else if (config.x5d_1.equals(ChannelOverflow_CLOSE_getInstance())) {
    tmp = new (BoundedChannel())(config.w5d_1);
  } else {
    // Inline function 'kotlin.error' call
    var message = 'Unsupported channel config.';
    throw IllegalStateException().o(toString(message));
  }
  return tmp;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        this.v5d_1 = new (ChannelConfig())(2147483647, ChannelOverflow_SUSPEND_getInstance());
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var ChannelConfigClass;
function ChannelConfig() {
  if (ChannelConfigClass === VOID) {
    class $ {
      constructor(capacity, onOverflow) {
        Companion_getInstance_0();
        this.w5d_1 = capacity;
        this.x5d_1 = onOverflow;
      }
      y5d() {
        return this.x5d_1.equals(ChannelOverflow_SUSPEND_getInstance()) && !(this.w5d_1 === 2147483647);
      }
    }
    initMetadataForClass($, 'ChannelConfig');
    ChannelConfigClass = $;
  }
  return ChannelConfigClass;
}
var ChannelOverflow_SUSPEND_instance;
var ChannelOverflow_CLOSE_instance;
var ChannelOverflow_entriesInitialized;
function ChannelOverflow_initEntries() {
  if (ChannelOverflow_entriesInitialized)
    return Unit_instance;
  ChannelOverflow_entriesInitialized = true;
  ChannelOverflow_SUSPEND_instance = new (ChannelOverflow())('SUSPEND', 0);
  ChannelOverflow_CLOSE_instance = new (ChannelOverflow())('CLOSE', 1);
}
var ChannelOverflowClass;
function ChannelOverflow() {
  if (ChannelOverflowClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'ChannelOverflow');
    ChannelOverflowClass = $;
  }
  return ChannelOverflowClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      z5d(capacity) {
        var channel = {_v: null};
        var tmp = BufferOverflow_DROP_OLDEST_getInstance();
        // Inline function 'kotlin.also' call
        var this_0 = Channel(capacity, tmp, (it) => {
          var tmp;
          var tmp_0;
          if (channel._v == null) {
            throwUninitializedPropertyAccessException('channel');
          } else {
            tmp_0 = channel._v;
          }
          if (!tmp_0.v1a()) {
            var tmp_1;
            if (channel._v == null) {
              throwUninitializedPropertyAccessException('channel');
            } else {
              tmp_1 = channel._v;
            }
            tmp_1.m1b(ChannelOverflowException().d5e('Channel overflowed'));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        channel._v = this_0;
        return this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  return Companion_instance_1;
}
var BoundedChannelClass;
function BoundedChannel() {
  if (BoundedChannelClass === VOID) {
    class $ {
      constructor(capacity, delegate) {
        delegate = delegate === VOID ? Companion_instance_1.z5d(capacity) : delegate;
        this.e5e_1 = delegate;
      }
      f5e(element) {
        var result = this.e5e_1.d1b(element);
        if (!_ChannelResult___get_isSuccess__impl__odq1z9(result) && !_ChannelResult___get_isClosed__impl__mg7kuu(result)) {
          this.m1b(ChannelOverflowException().d5e('Channel overflowed'));
        }
        return result;
      }
      d1b(element) {
        return this.f5e(element);
      }
      *g5e(element, $completion) {
        yield* this.e5e_1.c1b(element, $completion);
        return Unit_instance;
      }
      c1b(element, $completion) {
        return this.g5e(element, $completion);
      }
      m1b(cause) {
        return this.e5e_1.m1b(cause);
      }
      r1b(handler) {
        this.e5e_1.r1b(handler);
      }
      v1a() {
        return this.e5e_1.v1a();
      }
      *h5e($completion) {
        return yield* this.e5e_1.f1b($completion);
      }
      f1b($completion) {
        return this.h5e($completion);
      }
      p1() {
        return this.e5e_1.p1();
      }
      mx(cause) {
        this.e5e_1.mx(cause);
      }
    }
    protoOf($).o1b = close$default;
    protoOf($).q1b = cancel$default;
    initMetadataForClass($, 'BoundedChannel', VOID, VOID, [SendChannel(), ReceiveChannel()], [1, 0]);
    BoundedChannelClass = $;
  }
  return BoundedChannelClass;
}
var ChannelOverflowExceptionClass;
function ChannelOverflowException() {
  if (ChannelOverflowExceptionClass === VOID) {
    class $ extends RuntimeException() {
      constructor(message) {
        return new.target.d5e(message);
      }
      static d5e(message) {
        var $this = this.ra(message);
        captureStack($this, $this.c5e_1);
        return $this;
      }
    }
    initMetadataForClass($, 'ChannelOverflowException');
    ChannelOverflowExceptionClass = $;
  }
  return ChannelOverflowExceptionClass;
}
function ChannelOverflow_SUSPEND_getInstance() {
  ChannelOverflow_initEntries();
  return ChannelOverflow_SUSPEND_instance;
}
function ChannelOverflow_CLOSE_getInstance() {
  ChannelOverflow_initEntries();
  return ChannelOverflow_CLOSE_instance;
}
//region block: init
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Companion_getInstance as Companion_getInstance27kujspvp4jub,
  ChannelOverflow_SUSPEND_getInstance as ChannelOverflow_SUSPEND_getInstance2mwe7xoajis0a,
  ChannelConfig as ChannelConfigftdbykui5s0q,
  WebSocketChannelsConfig as WebSocketChannelsConfig1qogztyrywmj9,
  from as from3gpkuvfyl3bft,
};
//endregion

//# sourceMappingURL=WebSocketChannelsConfig.mjs.map
